export const hostingList = {
  rows: [
    {
      back_reference: 'WN.HP.729655442',
      feature_set: 'hosting_40s',
      account_info: {
        addon_back_ref: 'WN.HP.729655442',
        addon_id: '2672119',
        addon_status: 'active',
        brand: 'bluehost',
        brand_id: '3',
        date_added: '2025-07-24 07:32:41',
        date_modified: '2025-07-31 15:43:57',
        feature_set: 'hosting_40s',
        homedir: '/home1/pgcahbte',
        id: '1640767',
        ip: '50.6.8.14',
        meta: {
          main_domain: 'pgc.ahb.temp-bh.newfold-dev.site',
          prev_tenant: '1501387',
        },
        ns: ['ns1.betabh.com', 'ns2.betabh.com'],
        platform: 'jarvis',
        server_id: '918722',
        server_status: 'active',
        server_type: 'shared_cpanel',
        ssh_hostname: 'sh10468-bh.eigdev.com',
        status: 'active',
        tenant_id: '2595178',
        tenant_back_ref: '152534328',
        type: 'shared_cpanel',
        username: 'pgcahbte',
      },
      limit: {
        sites: '100',
        workers: 1,
        disk_limit_gib: '100',
      },
      package: 'Hosting-40s',
      panel: 'cpanel',
      sites: 1,
      used: {
        disk_usage: 370688,
        sites: 1,
        sites_active: 1,
        staging_sites: 0,
        workers: 1,
      },
    },
  ],
};
